import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0cc52a24 = () => interopDefault(import('../pages/zapis/success.vue' /* webpackChunkName: "pages/zapis/success" */))
const _1becdfe9 = () => interopDefault(import('../pages/zapis/error.vue' /* webpackChunkName: "pages/zapis/error" */))
const _39df6aae = () => interopDefault(import('../pages/zapis/_slug/index.vue' /* webpackChunkName: "pages/zapis/_slug/index" */))
const _4fb27c9a = () => interopDefault(import('../pages/zapis/index.vue' /* webpackChunkName: "pages/zapis/index" */))
const _66c19a90 = () => interopDefault(import('../pages/wishlist.vue' /* webpackChunkName: "pages/wishlist" */))
const _41ac91ca = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _40ded69c = () => interopDefault(import('../pages/vakansii/index.vue' /* webpackChunkName: "pages/vakansii/index" */))
const _5074bafa = () => interopDefault(import('../pages/uslugi/_slug/index.vue' /* webpackChunkName: "" */))
const _c83d8a02 = () => interopDefault(import('../pages/uslugi/index.vue' /* webpackChunkName: "pages/uslugi/index" */))
const _e2571238 = () => interopDefault(import('../pages/stat/_category/_article/index.vue' /* webpackChunkName: "pages/stat/_category/_article/index" */))
const _3d6c0d50 = () => interopDefault(import('../pages/stat/_category/index.vue' /* webpackChunkName: "pages/stat/_category/index" */))
const _1c8f7e8a = () => interopDefault(import('../pages/stat/index.vue' /* webpackChunkName: "pages/stat/index" */))
const _3fe3a26c = () => interopDefault(import('../pages/specialists/components/SpecialistCard.vue' /* webpackChunkName: "pages/specialists/components/SpecialistCard" */))
const _b4bdc132 = () => interopDefault(import('../pages/specialists/components/Header/SpecialistHeader.vue' /* webpackChunkName: "pages/specialists/components/Header/SpecialistHeader" */))
const _205fdb82 = () => interopDefault(import('../pages/specialists/index.vue' /* webpackChunkName: "" */))
const _2b3e5182 = () => interopDefault(import('../pages/search/components/Articles.vue' /* webpackChunkName: "pages/search/components/Articles" */))
const _89fcabc4 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _9cd998ca = () => interopDefault(import('../pages/reviews/AddReviewModal.vue' /* webpackChunkName: "pages/reviews/AddReviewModal" */))
const _1f5d517b = () => interopDefault(import('../pages/reviews/index.vue' /* webpackChunkName: "pages/reviews/index" */))
const _47d31baf = () => interopDefault(import('../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _0de2431d = () => interopDefault(import('../pages/questions-specialist/_question/index.vue' /* webpackChunkName: "pages/questions-specialist/_question/index" */))
const _2d0068b2 = () => interopDefault(import('../pages/questions-specialist/index.vue' /* webpackChunkName: "pages/questions-specialist/index" */))
const _2cf7804d = () => interopDefault(import('../pages/profile/zapis/index.vue' /* webpackChunkName: "pages/profile/zapis/index" */))
const _91873464 = () => interopDefault(import('../pages/profile/my-acuvue/index.vue' /* webpackChunkName: "pages/profile/my-acuvue/index" */))
const _2e097e34 = () => interopDefault(import('../pages/profile/edit/index.vue' /* webpackChunkName: "pages/profile/edit/index" */))
const _1914462f = () => interopDefault(import('../pages/profile/discount-card/_guid/index.vue' /* webpackChunkName: "pages/profile/discount-card/_guid/index" */))
const _bfc5f5d4 = () => interopDefault(import('../pages/profile/discount-card/index.vue' /* webpackChunkName: "pages/profile/discount-card/index" */))
const _34817d18 = () => interopDefault(import('../pages/profile/certificates/index.vue' /* webpackChunkName: "pages/profile/certificates/index" */))
const _df770ff2 = () => interopDefault(import('../pages/profile/bonuses/index.vue' /* webpackChunkName: "pages/profile/bonuses/index" */))
const _18c0cd89 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _d8df42b6 = () => interopDefault(import('../pages/product/test.vue' /* webpackChunkName: "pages/product/test" */))
const _3ba0cf76 = () => interopDefault(import('../pages/product/glassesCardPage_v2.vue' /* webpackChunkName: "pages/product/glassesCardPage_v2" */))
const _14cadff2 = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _663d53ad = () => interopDefault(import('../pages/checkout/success.vue' /* webpackChunkName: "" */))
const _5c6c5d56 = () => interopDefault(import('../pages/order/payment/cancel/_hash.vue' /* webpackChunkName: "pages/order/payment/cancel/_hash" */))
const _5137ed00 = () => interopDefault(import('../pages/order/payment/_hash.vue' /* webpackChunkName: "pages/order/payment/_hash" */))
const _5b07b777 = () => interopDefault(import('../pages/checkout/process/_hash.vue' /* webpackChunkName: "" */))
const _f201ffc0 = () => interopDefault(import('../pages/ochki/_category/index.vue' /* webpackChunkName: "pages/ochki/_category/index" */))
const _ec5e415c = () => interopDefault(import('../pages/ochki/index.vue' /* webpackChunkName: "pages/ochki/index" */))
const _44ae9325 = () => interopDefault(import('../pages/miopiya/indexOriginal.vue' /* webpackChunkName: "pages/miopiya/indexOriginal" */))
const _3f43334c = () => interopDefault(import('../pages/miopiya/components/QRList.vue' /* webpackChunkName: "pages/miopiya/components/QRList" */))
const _97b2f8d4 = () => interopDefault(import('../pages/miopiya/components/MiopiyaReasons.vue' /* webpackChunkName: "pages/miopiya/components/MiopiyaReasons" */))
const _f41c44ce = () => interopDefault(import('../pages/miopiya/components/MiopiyaPrevention.vue' /* webpackChunkName: "pages/miopiya/components/MiopiyaPrevention" */))
const _1bbee1b4 = () => interopDefault(import('../pages/miopiya/index.vue' /* webpackChunkName: "pages/miopiya/index" */))
const _36f028f2 = () => interopDefault(import('../pages/lenses/competitors/_slug.vue' /* webpackChunkName: "pages/lenses/competitors/_slug" */))
const _8f275b20 = () => interopDefault(import('../pages/lenses/_category/index.vue' /* webpackChunkName: "pages/lenses/_category/index" */))
const _6c01d5a2 = () => interopDefault(import('../pages/lenses/index.vue' /* webpackChunkName: "pages/lenses/index" */))
const _0ad79a69 = () => interopDefault(import('../pages/information_message/informationMessage.vue' /* webpackChunkName: "pages/information_message/informationMessage" */))
const _b37d0ed4 = () => interopDefault(import('../pages/company/questions/page.vue' /* webpackChunkName: "pages/company/questions/page" */))
const _7f463770 = () => interopDefault(import('../pages/company/questions/letterModal.vue' /* webpackChunkName: "pages/company/questions/letterModal" */))
const _654e13c4 = () => interopDefault(import('../pages/cms-page-preview/index.vue' /* webpackChunkName: "pages/cms-page-preview/index" */))
const _875eebac = () => interopDefault(import('../pages/checkout/process/new.vue' /* webpackChunkName: "pages/checkout/process/new" */))
const _1cab6bdc = () => interopDefault(import('../pages/checkout/process/index.vue' /* webpackChunkName: "pages/checkout/process/index" */))
const _a9048d08 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _7bff57f6 = () => interopDefault(import('../pages/charity/_category/_article/index.vue' /* webpackChunkName: "pages/charity/_category/_article/index" */))
const _471787f4 = () => interopDefault(import('../pages/charity/_category/index.vue' /* webpackChunkName: "pages/charity/_category/index" */))
const _8782ba90 = () => interopDefault(import('../pages/charity/index.vue' /* webpackChunkName: "pages/charity/index" */))
const _09fd1ad3 = () => interopDefault(import('../pages/catalog/components/SelectedFilter.vue' /* webpackChunkName: "pages/catalog/components/SelectedFilter" */))
const _71af0f9a = () => interopDefault(import('../pages/catalog/components/FilterMobileComponent.vue' /* webpackChunkName: "pages/catalog/components/FilterMobileComponent" */))
const _4c4f39b5 = () => interopDefault(import('../pages/catalog/components/FilterComponent.vue' /* webpackChunkName: "pages/catalog/components/FilterComponent" */))
const _24cb34b7 = () => interopDefault(import('../pages/catalog/components/ContactLinzCategory.vue' /* webpackChunkName: "pages/catalog/components/ContactLinzCategory" */))
const _e4287414 = () => interopDefault(import('../pages/catalog/components/ArticleCard.vue' /* webpackChunkName: "pages/catalog/components/ArticleCard" */))
const _4fafc086 = () => interopDefault(import('../pages/catalog/_.vue' /* webpackChunkName: "pages/catalog/_" */))
const _69cc57f9 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _74a72bfb = () => interopDefault(import('../pages/cart_old.vue' /* webpackChunkName: "pages/cart_old" */))
const _141d5372 = () => interopDefault(import('../pages/cart/checkout.vue' /* webpackChunkName: "pages/cart/checkout" */))
const _1e3f64d8 = () => interopDefault(import('../pages/cart-old/done.vue' /* webpackChunkName: "pages/cart-old/done" */))
const _7504f2bc = () => interopDefault(import('../pages/cart-old/basketPageThirdStep.vue' /* webpackChunkName: "pages/cart-old/basketPageThirdStep" */))
const _ca11d572 = () => interopDefault(import('../pages/cart-old/basketPageSecondStep.vue' /* webpackChunkName: "pages/cart-old/basketPageSecondStep" */))
const _c8dbada0 = () => interopDefault(import('../pages/cart-old/index.vue' /* webpackChunkName: "pages/cart-old/index" */))
const _64753754 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _45ef3d2a = () => interopDefault(import('../pages/bystraya-zapis/index.vue' /* webpackChunkName: "pages/bystraya-zapis/index" */))
const _0e57eece = () => interopDefault(import('../pages/authorization/index.vue' /* webpackChunkName: "pages/authorization/index" */))
const _528b8be8 = () => interopDefault(import('../pages/appointment/appointment.vue' /* webpackChunkName: "pages/appointment/appointment" */))
const _d7cfa38c = () => interopDefault(import('../pages/aktsii/_slug/index.vue' /* webpackChunkName: "pages/aktsii/_slug/index" */))
const _6eec1e3f = () => interopDefault(import('../pages/aktsii/index.vue' /* webpackChunkName: "pages/aktsii/index" */))
const _ff28e3bc = () => interopDefault(import('../pages/acuvue/phoneRegistrationForm.vue' /* webpackChunkName: "pages/acuvue/phoneRegistrationForm" */))
const _56389ec9 = () => interopDefault(import('../pages/acuvue/index.vue' /* webpackChunkName: "pages/acuvue/index" */))
const _204626fc = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/zapis/success",
    component: _0cc52a24,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-success"
  }, {
    path: "/zapis/error",
    component: _1becdfe9,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-error"
  }, {
    path: "/zapis/:slug",
    component: _39df6aae,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-slug"
  }, {
    path: "/zapis",
    component: _4fb27c9a,
    pathToRegexpOptions: {"strict":true},
    name: "zapis"
  }, {
    path: "/wishlist",
    component: _66c19a90,
    pathToRegexpOptions: {"strict":true},
    name: "wishlist"
  }, {
    path: "/video",
    component: _41ac91ca,
    pathToRegexpOptions: {"strict":true},
    name: "video"
  }, {
    path: "/vakansii",
    component: _40ded69c,
    pathToRegexpOptions: {"strict":true},
    name: "vakansii"
  }, {
    path: "/uslugi/:slug/:service",
    components: {
      default: _5074bafa
    }
  }, {
    path: "/uslugi/:slug",
    component: _5074bafa,
    pathToRegexpOptions: {"strict":true},
    name: "uslugi-slug"
  }, {
    path: "/uslugi",
    component: _c83d8a02,
    pathToRegexpOptions: {"strict":true},
    name: "uslugi"
  }, {
    path: "/stat/:category/:article",
    component: _e2571238,
    pathToRegexpOptions: {"strict":true},
    name: "stat-category-article"
  }, {
    path: "/stat/:category",
    component: _3d6c0d50,
    pathToRegexpOptions: {"strict":true},
    name: "stat-category"
  }, {
    path: "/stat",
    component: _1c8f7e8a,
    pathToRegexpOptions: {"strict":true},
    name: "stat"
  }, {
    path: "/specialists/components/SpecialistCard",
    component: _3fe3a26c,
    pathToRegexpOptions: {"strict":true},
    name: "specialists-components-SpecialistCard"
  }, {
    path: "/specialists/components/Header/SpecialistHeader",
    component: _b4bdc132,
    pathToRegexpOptions: {"strict":true},
    name: "specialists-components-Header-SpecialistHeader"
  }, {
    path: "/specialists/:id",
    components: {
      default: _205fdb82
    }
  }, {
    path: "/specialists",
    component: _205fdb82,
    pathToRegexpOptions: {"strict":true},
    name: "specialists"
  }, {
    path: "/search/components/Articles",
    component: _2b3e5182,
    pathToRegexpOptions: {"strict":true},
    name: "search-components-Articles"
  }, {
    path: "/search",
    component: _89fcabc4,
    pathToRegexpOptions: {"strict":true},
    name: "search"
  }, {
    path: "/reviews/AddReviewModal",
    component: _9cd998ca,
    pathToRegexpOptions: {"strict":true},
    name: "reviews-AddReviewModal"
  }, {
    path: "/reviews",
    component: _1f5d517b,
    pathToRegexpOptions: {"strict":true},
    name: "reviews"
  }, {
    path: "/registration",
    component: _47d31baf,
    pathToRegexpOptions: {"strict":true},
    name: "registration"
  }, {
    path: "/questions-specialist/:question",
    component: _0de2431d,
    pathToRegexpOptions: {"strict":true},
    name: "questions-specialist-question"
  }, {
    path: "/questions-specialist",
    component: _2d0068b2,
    pathToRegexpOptions: {"strict":true},
    name: "questions-specialist"
  }, {
    path: "/profile/zapis",
    component: _2cf7804d,
    pathToRegexpOptions: {"strict":true},
    name: "profile-zapis"
  }, {
    path: "/profile/my-acuvue",
    component: _91873464,
    pathToRegexpOptions: {"strict":true},
    name: "profile-my-acuvue"
  }, {
    path: "/profile/edit",
    component: _2e097e34,
    pathToRegexpOptions: {"strict":true},
    name: "profile-edit"
  }, {
    path: "/profile/discount-card/:guid",
    component: _1914462f,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card-guid"
  }, {
    path: "/profile/discount-card",
    component: _bfc5f5d4,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card"
  }, {
    path: "/profile/certificates",
    component: _34817d18,
    pathToRegexpOptions: {"strict":true},
    name: "profile-certificates"
  }, {
    path: "/profile/bonuses",
    component: _df770ff2,
    pathToRegexpOptions: {"strict":true},
    name: "profile-bonuses"
  }, {
    path: "/profile",
    component: _18c0cd89,
    pathToRegexpOptions: {"strict":true},
    name: "profile"
  }, {
    path: "/product/test",
    component: _d8df42b6,
    pathToRegexpOptions: {"strict":true},
    name: "product-test"
  }, {
    path: "/product/glassesCardPage_v2",
    component: _3ba0cf76,
    pathToRegexpOptions: {"strict":true},
    name: "product-glassesCardPage_v2"
  }, {
    path: "/product/:slug?",
    component: _14cadff2,
    pathToRegexpOptions: {"strict":true},
    name: "product-slug"
  }, {
    path: "/order/success/:hash",
    components: {
      default: _663d53ad
    }
  }, {
    path: "/order/payment/cancel/:hash?",
    component: _5c6c5d56,
    pathToRegexpOptions: {"strict":true},
    name: "order-payment-cancel-hash"
  }, {
    path: "/order/payment/:hash?",
    component: _5137ed00,
    pathToRegexpOptions: {"strict":true},
    name: "order-payment-hash"
  }, {
    path: "/order/:hash",
    components: {
      default: _5b07b777
    }
  }, {
    path: "/ochki/:category",
    component: _f201ffc0,
    pathToRegexpOptions: {"strict":true},
    name: "ochki-category"
  }, {
    path: "/ochki",
    component: _ec5e415c,
    pathToRegexpOptions: {"strict":true},
    name: "ochki"
  }, {
    path: "/miopiya/indexOriginal",
    component: _44ae9325,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-indexOriginal"
  }, {
    path: "/miopiya/components/QRList",
    component: _3f43334c,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-QRList"
  }, {
    path: "/miopiya/components/MiopiyaReasons",
    component: _97b2f8d4,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-MiopiyaReasons"
  }, {
    path: "/miopiya/components/MiopiyaPrevention",
    component: _f41c44ce,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-MiopiyaPrevention"
  }, {
    path: "/miopiya",
    component: _1bbee1b4,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya"
  }, {
    path: "/lenses/competitors/:slug?",
    component: _36f028f2,
    pathToRegexpOptions: {"strict":true},
    name: "lenses-competitors-slug"
  }, {
    path: "/lenses/:category",
    component: _8f275b20,
    pathToRegexpOptions: {"strict":true},
    name: "lenses-category"
  }, {
    path: "/lenses",
    component: _6c01d5a2,
    pathToRegexpOptions: {"strict":true},
    name: "lenses"
  }, {
    path: "/information_message/informationMessage",
    component: _0ad79a69,
    pathToRegexpOptions: {"strict":true},
    name: "information_message-informationMessage"
  }, {
    path: "/company/questions/page",
    component: _b37d0ed4,
    pathToRegexpOptions: {"strict":true},
    name: "company-questions-page"
  }, {
    path: "/company/questions/letterModal",
    component: _7f463770,
    pathToRegexpOptions: {"strict":true},
    name: "company-questions-letterModal"
  }, {
    path: "/cms-page-preview",
    component: _654e13c4,
    pathToRegexpOptions: {"strict":true},
    name: "cms-page-preview"
  }, {
    path: "/checkout/success",
    component: _663d53ad,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-success"
  }, {
    path: "/checkout/process/new",
    component: _875eebac,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process-new"
  }, {
    path: "/checkout/process/:hash",
    component: _5b07b777,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process-hash"
  }, {
    path: "/checkout/process",
    component: _1cab6bdc,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process"
  }, {
    path: "/checkout",
    component: _a9048d08,
    pathToRegexpOptions: {"strict":true},
    name: "checkout"
  }, {
    path: "/charity/:category/:article",
    component: _7bff57f6,
    pathToRegexpOptions: {"strict":true},
    name: "charity-category-article"
  }, {
    path: "/charity/:category",
    component: _471787f4,
    pathToRegexpOptions: {"strict":true},
    name: "charity-category"
  }, {
    path: "/charity",
    component: _8782ba90,
    pathToRegexpOptions: {"strict":true},
    name: "charity"
  }, {
    path: "/catalog/components/SelectedFilter",
    component: _09fd1ad3,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-SelectedFilter"
  }, {
    path: "/catalog/components/FilterMobileComponent",
    component: _71af0f9a,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-FilterMobileComponent"
  }, {
    path: "/catalog/components/FilterComponent",
    component: _4c4f39b5,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-FilterComponent"
  }, {
    path: "/catalog/components/ContactLinzCategory",
    component: _24cb34b7,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-ContactLinzCategory"
  }, {
    path: "/catalog/components/ArticleCard",
    component: _e4287414,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-ArticleCard"
  }, {
    path: "/catalog/*",
    component: _4fafc086,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-all"
  }, {
    path: "/catalog",
    component: _69cc57f9,
    pathToRegexpOptions: {"strict":true},
    name: "catalog"
  }, {
    path: "/cart_old",
    component: _74a72bfb,
    pathToRegexpOptions: {"strict":true},
    name: "cart_old"
  }, {
    path: "/cart/checkout",
    component: _141d5372,
    pathToRegexpOptions: {"strict":true},
    name: "cart-checkout"
  }, {
    path: "/cart-old/done",
    component: _1e3f64d8,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-done"
  }, {
    path: "/cart-old/basketPageThirdStep",
    component: _7504f2bc,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-basketPageThirdStep"
  }, {
    path: "/cart-old/basketPageSecondStep",
    component: _ca11d572,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-basketPageSecondStep"
  }, {
    path: "/cart-old",
    component: _c8dbada0,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old"
  }, {
    path: "/cart",
    component: _64753754,
    pathToRegexpOptions: {"strict":true},
    name: "cart"
  }, {
    path: "/bystraya-zapis",
    component: _45ef3d2a,
    pathToRegexpOptions: {"strict":true},
    name: "bystraya-zapis"
  }, {
    path: "/authorization",
    component: _0e57eece,
    pathToRegexpOptions: {"strict":true},
    name: "authorization"
  }, {
    path: "/appointment/appointment",
    component: _528b8be8,
    pathToRegexpOptions: {"strict":true},
    name: "appointment-appointment"
  }, {
    path: "/aktsii/:slug",
    component: _d7cfa38c,
    pathToRegexpOptions: {"strict":true},
    name: "aktsii-slug"
  }, {
    path: "/aktsii",
    component: _6eec1e3f,
    pathToRegexpOptions: {"strict":true},
    name: "aktsii"
  }, {
    path: "/acuvue/phoneRegistrationForm",
    component: _ff28e3bc,
    pathToRegexpOptions: {"strict":true},
    name: "acuvue-phoneRegistrationForm"
  }, {
    path: "/acuvue",
    component: _56389ec9,
    pathToRegexpOptions: {"strict":true},
    name: "acuvue"
  }, {
    path: "/*",
    component: _204626fc,
    pathToRegexpOptions: {"strict":true},
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
